export default __webpack_public_path__ + "static/real-time-data-updates-fef564d446d948dc092b3ce552985b86.png";